/* eslint-disable */

/**
 * @module Login
 */
import $ from 'jquery'
import GlobalFunctions, { appconfig } from '@/global'

export default {
  /**
   * Call to unoapp API to get config variables.
   * CORS allows ports: 3001, 3002, 3003, 8000, 8001, 8002, 8003, 6969
   * @function
   * @returns {object} A promise that will return either a success object or an error object.
   */
  getConfig: function () {
    const {environment, headers, origin, url} = appconfig

    return new Promise(function (resolve, reject) {
      $.ajax({
        method: 'GET',
        dataType: 'json',
        url,
        data: {
          origin,
          env: environment
        },
        headers,
        success: response => resolve(response),
        error: error => reject(error)
      })
    })
  },
  /**
   * Call to unoapp API to log the application admin in.
   * @function
   * @param {string} token - The authentication token.
   * @returns {object} A promise that will return either a success object or an error object.
   */
  login: function (token) {
    return new Promise(function (resolve, reject) {
      GlobalFunctions.$ajax({
        method: 'POST',
        dataType: 'json',
        url: '/application/admin/login',
        data: { token },
        success: function (response) {
          resolve(response)
        },
        error: function (error) {
          reject(error)
        }
      }, 'authorization')
    })
  }
}
